'use client'

import clsx from 'clsx'
import { AdvertisingModalEmbedded } from '@/AdvertisingModal/AdvertisingModalEmbedded'
import type { AdvertisingModalContent } from '@/AdvertisingModal/types'
import type { CustomerIoWorkspace } from '@/generated/graphql'
import {
  FREEMAGIC_REGISTERED_FREE_DOWNLOAD_EVENT,
  FREEMAGIC_TRACKING_SOURCE,
} from '@/freemagicTracking'
import {
  freemagicEmbeddedChrome,
  withFreemagicFormFields,
} from '../embeddedDefaults'
import { FreemagicFormPrivacy } from './FormPrivacy'

const { embeddedClassName: _shellClass, ...restChrome } = freemagicEmbeddedChrome
const embeddedChromeProps = {
  stackedContentClassName: '!px-0 !pb-0 !pt-0',
  ...restChrome,
} as const

export type FreemagicJumbotronEmbeddedProps = {
  content: Omit<AdvertisingModalContent, 'formFields'>
  /** Kissmetrics-style `Free download name` (stable per campaign). */
  freeDownloadName: string
  layout: 'side-by-side' | 'stacked'
  howSignedUp?: number
  hideForLoggedInUsers?: boolean
  showFormForLoggedInUsers?: boolean
  enableCaptcha?: boolean
  successRedirectUrl?: string
  embeddedClassName?: string
  /** CustomerIO segment to add the customer to on successful signup.
   * Transactional email support will be added once the backend resolver is deployed. */
  customerIo?: {
    segmentId?: number
    workspace?: CustomerIoWorkspace
  }
}

/** Inline signup card + privacy line (shared by free-product and embedded-only flows). */
export function FreemagicJumbotronEmbedded({
  content,
  freeDownloadName,
  layout,
  howSignedUp = 1,
  hideForLoggedInUsers,
  showFormForLoggedInUsers,
  enableCaptcha,
  successRedirectUrl,
  embeddedClassName,
  customerIo,
}: FreemagicJumbotronEmbeddedProps) {
  return (
    <div className="border-[10px] border-solid border-[#28a745] bg-[#eee] px-4 pb-4 pt-4 text-[#212529]">
      <AdvertisingModalEmbedded
        content={withFreemagicFormFields(content)}
        trackingEventName={FREEMAGIC_REGISTERED_FREE_DOWNLOAD_EVENT}
        trackingProperties={{
          'Free download name': freeDownloadName,
          source: FREEMAGIC_TRACKING_SOURCE,
        }}
        config={{
          layout,
          hideForLoggedInUsers: hideForLoggedInUsers ?? false,
          showFormForLoggedInUsers: showFormForLoggedInUsers ?? true,
          enableCaptcha: enableCaptcha ?? true,
        }}
        howSignedUp={howSignedUp}
        successRedirectUrl={successRedirectUrl}
        customerIo={customerIo}
        className={clsx(
          freemagicEmbeddedChrome.embeddedClassName,
          embeddedClassName
        )}
        {...embeddedChromeProps}
      />
      <FreemagicFormPrivacy />
    </div>
  )
}

